'use client'
import { Icons } from '@/app/components/ui/Icons'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useParams } from 'next/navigation'
import { FC } from 'react'
import {
	emitContactUsClickGAEvent,
	emitPrivacyPolicyClickGAEvent,
	emitTermOfUseClickGAEvent,
} from '../ga-event-helpers'

const FOOTER_NAV_ITEMS = [
	{
		href: '/contact-us',
		title: 'contactUs',
		onClick() {
			emitContactUsClickGAEvent()
		},
	},
	{
		href: '/terms',
		title: 'terms',
		onClick() {
			emitTermOfUseClickGAEvent()
		},
	},
	{
		href: '/privacy-policy',
		title: 'privacyPolicy',
		onClick() {
			emitPrivacyPolicyClickGAEvent()
		},
	},
]

const FooterNav: FC = () => {
	const t = useTranslations('Footer')
	const params = useParams()

	return (
		<nav className="footer-nav">
			<ul>
				{FOOTER_NAV_ITEMS.map((item, i) => (
					<li
						key={i}
						className="flex max-md:flex-col max-md:items-start items-center"
					>
						<div className="nav-item flex justify-between md:justify-center items-center w-full">
							<Link
								href={`/${params.lang}/${item.href}`}
								aria-label={t(item.title)}
								onClick={() => item.onClick?.()}
								className={classNames(
									// Text styles
									'text-text-900 font-bold leading-5',
									// Padding and sizing
									'py-3 lg:py-2 lg:px-8',
									'max-lg:w-full',
									// Flexbox (for larger screens)
									'max-lg:flex max-lg:items-center max-lg:justify-between',
									// Shape
									'rounded-full',
									// Interactive styles
									'transition-colors lg:hover:bg-text-300'
								)}
							>
								{t(item.title)}
								<Icons.chevronSmall className="md:hidden" />
							</Link>
						</div>
						<div
							className={classNames(
								'w-full h-[1px] md:h-[30px] md:w-[1px] bg-text-300 md:mx-8 my-1 md:my-0',
								{
									'md:hidden': i === FOOTER_NAV_ITEMS.length - 1,
								}
							)}
						/>
					</li>
				))}
			</ul>
		</nav>
	)
}

export default FooterNav
